import GodiverseDetailPage from '@pages/emporium/godiverse/detail'
import type { NextPage } from 'next'

const GodiverseOtherDetailPage: NextPage<Props> = () => {
  return <GodiverseDetailPage />
}

type Props = {}

export default GodiverseOtherDetailPage
